import React from "react";
// import VerticalSpace from "../VerticalSpace";

import "./input.sass";

function Input(props) {
  const {
    file,
    title,
    value,
    onChange,
    click,
    required = false,
    hint,
    hintColor = "#000",
    error,
    maxWidth,
    margin,
    input = false,
    textarea = false,
    node = null,
    maxLength,
    placeholder,
    borderRadius,
    type,
    textAlign = "right",
    direction = "rtl",
    className,
    ...others
  } = props;
  return (
    <div
      className={`input-box relative z-20 ${className}`}
      {...others}
      style={{ maxWidth, margin }}
    >
      <div className='input-body' onClick={click}>
        <div className='input-title '>
          {title}

          {required ? <span className='input-required-sign'>*</span> : ""}
        </div>

        {input && (
          <input
            className={`input-field ${error ? "border-error" : ""}`}
            // ref={node}
            maxLength={maxLength}
            autoComplete="off"
            placeholder={placeholder}
            type={type}
            // value={value}
            style={{
              borderRadius: `${borderRadius ? borderRadius : "10px"}`,
              textAlign,
              direction,
            }}
            value={value}
            onChange={onChange}
            {...others}
          />
        )}

        {textarea && (
          <textarea
            className={`input-textarea-field ${error ? "border-error" : ""}`}
            ref={node}
            maxLength={maxLength}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            {...others}
          />
        )}
      </div>
      {hint ? (
        <>
          <div className='text-xs my-1' style={{ color: hintColor }}>
            {hint}
          </div>
        </>
      ) : (
        <></>
      )}
      {error ? (
        <>
          <span className='input-error-text'>{error}</span>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
export default Input;
